import {useSyncExternalStore} from 'react';

// Tiny module-level stores shared by the custom Header, Home and Profile page.
const createStore=(initial)=>{
    let value=initial;
    const listeners=new Set();
    const set=(next)=>{
        if(next===value){return;}
        value=next;
        listeners.forEach((listener)=>listener());
    };
    const subscribe=(listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const useValue=()=>useSyncExternalStore(subscribe,()=>value);
    return {set,useValue};
};

// core App.js hands userData (role_name, user_name, ...) to Header/Footer and
// pages, but not to Home - which only gets roleConfig. The custom Header
// publishes it here so Home can tell a consumer from staff without a core change.
const userDataStore=createStore({});
export const setCurrentUserData=(userData)=>userDataStore.set(userData||{});
export const useCurrentUserData=userDataStore.useValue;

// Own profile picture: data URL, null = none, undefined = not loaded yet.
// Loaded once by the custom Header and replaced by ProfilePictureEditor after
// an upload/remove, so the header avatar, Home and Profile all change together
// without a refetch.
const profilePictureStore=createStore(undefined);
export const setCurrentProfilePicture=(picture)=>profilePictureStore.set(picture||null);
export const useCurrentProfilePicture=profilePictureStore.useValue;
